import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ProductPage.scss';
import Breadcrumb from '../../components/common/Breadcrumb';

const productImages = {
  masking: '/images/tape5.png',
  line: '/images/tape6.png',
};

const Industrial = () => {
  const { subcategory } = useParams();
  const navigate = useNavigate();

  const products = {
    masking: {
      title: '마스킹테이프',
      eng: 'Masking Tape',
      desc: '고무계 접착제를 사용하고 고품질의 아이보리 색종이(Crepe Paper)로 코팅된 자동차 도장용 테이프입니다.',
      summary: {
        productName: 'KM 500 / KM 800',
        usage: '자동차 도장용',
        size: 'KM500: 120±20 / KM800: 152±20',
      },
      strengths: [
        '고품질의 아이보리 색종이코팅',
        '생 고무계 점착제사용',
        '최고 90°C의 내열성을 가져 자동차 도장 베이킹 사이클에 적합',
        '황색, 흑색, 녹색, 청색, 적색 등 다양한 색상 가능',
        '자동차 표면 작업 후 제거 시 잔사가 남지 않음',
      ],
      cautions: ['위 수치는 테스트의 평균치이며 소비자용 보증치는 아닙니다.'],
      // 이미지 하단 상세 표의 항목을 그대로 반영
      tableHeaders: [
        '제품번호(Model)',
        '기재(Carrier)',
        '점착제(Adhesive)',
        '두께(mm)',
        '180° Peel(g/in)',
        '색상',
        '인장강도',
        '내열성(°C)',
      ],
      tableRows: [
        ['KM 500', 'CREPE PAPER', 'Natural rubber', '120±20', '700 over', '반투명', '8.9 over', '70'],
        ['KM 800', 'CREPE PAPER', 'Natural rubber', '152±20', '1,000 over', '반투명', '8 over', '90'],
      ],
    },
    line: {
      title: '라인 테이프',
      eng: 'Floor Marking Tape',
      desc: '방수에 탁월하며 유분기에도 강한 PVC 필름 기반의 테이프로, 난간과 바닥 표면에 붙일 수 있습니다.',
      summary: {
        productName: '라인 테이프',
        usage: '난간 및 바닥 표면 부착',
        size: '두께 0.15±0.01mm',
      },
      strengths: [
        '방수에 탁월하며 유분기에 강함',
        'PVC 필름 기재와 아크릴/고무계 점착제 구조',
        '난간 및 바닥 표면에 용이한 부착성',
      ],
      cautions: ['위 수치는 테스트의 평균치이며 소비자용 보증치는 아닙니다.'],
      // 이미지 하단 L150 상세 데이터 반영
      tableHeaders: [
        '제품번호(Model)',
        '기재(Carrier)',
        'Backing(mm)',
        '두께(mm)',
        'Ball Tack',
        '늘어짐(Elongation)',
        '점착력(gf/in)',
        '내열성(°C)',
      ],
      tableRows: [['L150', 'PVC', '0.13±0.01', '0.15±0.01', '8# Steel Ball', '150 over', '750', '4~77']],
    },
  };

  const currentKey = subcategory || 'masking';
  const current = products[currentKey] || products['masking'];

  return (
    <div className="sub-page product-page">
      <section className="sub-visual product">
        <div className="container">
          <span className="sub-title">PRODUCT</span>
          <h1>제품소개</h1>
          <p>현장의 효율과 안전을 높이는 산업 전용 시리즈입니다.</p>
        </div>
      </section>

      <Breadcrumb />

      <nav className="category-nav">
        <div className="container">
          <div className="nav-inner">
            <button onClick={() => navigate('/products/double-sided/whaja')}>양면 테이프</button>
            <button className="active" onClick={() => navigate('/products/industrial/masking')}>
              산업용 테이프
            </button>
            <button onClick={() => navigate('/products/foam/eva')}>폼 테이프</button>
          </div>
        </div>
      </nav>

      <div className="container content-wrap">
        <nav className="product-tabs">
          {Object.keys(products).map((key) => (
            <button
              key={key}
              className={currentKey === key ? 'active' : ''}
              onClick={() => navigate(`/products/industrial/${key}`)}
            >
              {products[key].title}
            </button>
          ))}
        </nav>

        <div className="product-detail-view">
          <div className="detail-main">
            <div className="img-area">
              <div className="img-box">
                <img src={productImages[currentKey]} alt={current.title} />
              </div>
            </div>

            <div className="info-area info-area-redesign">
              <div className="product-head">
                <span className="eng-title">{current.eng}</span>
                <h2>{current.title}</h2>
                <p className="main-desc">{current.desc}</p>
              </div>

              <div className="spec-table-container">
                <table className="spec-table">
                  <tbody>
                    <tr>
                      <th>품명</th>
                      <td>
                        <strong>{current.summary.productName}</strong>
                      </td>
                    </tr>
                    <tr>
                      <th>사용처</th>
                      <td>{current.summary.usage}</td>
                    </tr>
                    <tr>
                      <th>특장점</th>
                      <td>
                        <ul className="spec-list strengths">
                          {current.strengths.map((s, idx) => (
                            <li key={idx}>{s}</li>
                          ))}
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <th>규격</th>
                      <td>{current.summary.size}</td>
                    </tr>
                    <tr>
                      <th>주의사항</th>
                      <td>
                        <ul className="spec-list cautions">
                          {current.cautions.map((c, idx) => (
                            <li key={idx}>{c}</li>
                          ))}
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="data-table-wrap full-width">
            <div className="table-title">상세 규격 데이터 (Technical Specification)</div>
            <div className="table-scroll">
              <table className="product-data-table">
                <thead>
                  <tr>
                    {current.tableHeaders.map((head, idx) => (
                      <th key={idx}>{head}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {current.tableRows.map((row, rowIdx) => (
                    <tr key={rowIdx}>
                      {row.map((cell, cellIdx) => (
                        <td key={cellIdx}>{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Industrial;
